import React from 'react';
import classes from './SurveyTips.qmee.module.scss';
import { SurveyTip } from 'constants/QmeeSurveyTips';
import Txt from 'components/atoms/Txt/Txt';
import SurveyTipItem from './SurveyTipItem';
import Heading from 'components/atoms/Heading/Heading';
import PageHeader from 'components/molecules/PageHeader/PageHeader';
import { MORE } from 'components/pages/pages';

export interface Props {
  surveyTips: Array<SurveyTip>;
}

const SurveyTips: React.FC<Props> = ({ surveyTips }) => {
  return (
    <main className={classes.root}>
      <PageHeader title="Survey Tips" backHref={MORE.path} />
      <Heading level={1} className={classes.surveyTipsTitle}>
        Survey Tips
      </Heading>
      <Txt component="p">
        Survey providers are constantly analyzing your behaviour to ensure you are giving genuine,
        honest answers during surveys.
      </Txt>
      <Txt component="p">
        If the providers are happy, it&apos;ll mean less declines &amp; a better survey experience
        for you - which is what we all want! To make this easier, we think it&apos;s really useful
        to understand what the survey providers are looking for.
      </Txt>
      <Txt component="p">
        So, check out the tips we&apos;ve provided to help you become a &apos;Survey Winner&apos;
      </Txt>
      <section className={classes.surveyTipsListWrapper}>
        <div className={classes.surveyTipsList}>
          {surveyTips.map((tip, index) => (
            <SurveyTipItem key={tip.path} tip={tip} index={index} />
          ))}
        </div>
      </section>
    </main>
  );
};

export default SurveyTips;
